import React from 'react';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import { historyList } from './data';
import './Styles/History.scss';
import Select from 'react-select';
const style = {
    control: base => ({
      ...base,
      border: 0,
      boxShadow: "none",
      border: "1px solid #d3d3d3",
      borderRadius: "8px",
      height: "45px",
      backgroundColor:"rgba(128, 128, 128, 0.01)",
      color:"white"
    })
  };
const History=()=>{
    return(
        <div className="history-status" >
            <div className="container">
            <div className="section">
                <h1>Incident History</h1>
                <div className="select">
                    <p>Jump to month:</p>
                    <Select 
            className="selectform"
            styles={style}
            placeholder='July 2021'
            theme={theme => ({
            ...theme,
            borderRadius: 0,
            // textAlign:'left',
            colors: {
              ...theme.colors,
              primary25: ' rgba(128, 128, 128, 0.178)',
              primary: ' #000e29a4',
            },
          })}
        />
                </div>
            </div>
            <div className="cards">
            {historyList.map((d) =>{
                return(
                    <Card {...d}/>
                )
            })}
            </div>
            </div>
        </div>
    )
};
export default History ;

export function Card(props){
    return(
        <div className="key-card"  data-aos={props.fade}
        data-aos-delay={props.delay}>
            <div className="title">
                <p>{props.icon} {props.date}</p>
 
            </div>
                <h2>{props.title}</h2>
                <h5>{props.sub}</h5>
                <h4>Resolved</h4>
                <p>{props.desc}</p>
                <StyledButton btn="Full Report" styles="nobg-btn" />
        </div>
    )
};
